export default __webpack_public_path__ + "static/media/galaxy_s9.02752ad8.svg";